import * as React from "react";
import { HTTPService } from "../../common/services/httpService";
import { IAPIResponse, IHTTPResponse } from "../../common/models/httpModels";
import { CommonConstants } from "../../common/constants/common-constants";
import { IFPFileDeleteRequest, IFoundationProgramFileRequest } from "./foundationProgramModels";
import { IFoundationProgramFile } from "../../common/models/foundationProgram";


const httpService = new HTTPService();
const fileUpload = (files: File[], fileRequest: IFoundationProgramFileRequest): Promise<IHTTPResponse<IAPIResponse<any>>> => {
  const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.FoundationProgramFileUpload
    }`;
  const formData = new FormData();
  files.forEach((file) => { formData.append('files', file) });

  formData.append('programId', fileRequest.programId.toString());
  formData.append('classId', fileRequest.classId.toString());
  formData.append('workSheetId', fileRequest.workSheetId.toString());
  formData.append('subjectId', fileRequest.subjectId != undefined ? fileRequest.subjectId.toString() : "");

  return httpService.fileUpload(url, formData);
};

const getFiles = (programId: number, classId: number): Promise<IHTTPResponse<IAPIResponse<IFoundationProgramFile>>> => {

  const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.FoundationProgramFiles}`;

  return httpService.get(`${url}/${programId}/${classId}`);
}

const deleteFile = (deleteFileRequest: IFPFileDeleteRequest): Promise<IHTTPResponse<IAPIResponse<IFoundationProgramFile>>> => {

  const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.FoundationProgramDeleteFile}`;

  return httpService.post(url, deleteFileRequest);
}

const getFileDownloadUrl = (fileId: number): string => {

  const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.FoundationProgramDownloadFile}/${fileId}`;

  return url;
}

const FoundationProgramService = {
  fileUpload,
  getFiles,
  deleteFile,
  getFileDownloadUrl
};

export default FoundationProgramService;
